export default {
  TITLE: 'Hassle free Exchanges & Returns, just a scan away',
  DESCRIPTION:
    'No need to print a return label. Simply take your return package to the nearest supporting USPS facility and scan your QR code for a fast and easy experience.',
  INPUT_LABEL:
    'Enter your zipcode to see the nearest USPS locations that support QR codes.'
};
